import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import { makeHttpParams } from './utils';

export interface TicketsSearchRequest {
  limit: number;
  page: number;
  status: string;
}

export interface TicketsSearchResponse {
  total: number;
}

export interface TicketCounterResponse {
  total: number;
}

@Injectable()
export class TicketApiService {

  private URL: string = environment.angularJSconstants.URL_API_ATENDIMENTO;

  constructor(private http: HttpClient) {}

  searchTickets(request: TicketsSearchRequest): Observable<TicketsSearchResponse> {
    const token = localStorage.getItem('ls.token').replace(/"/g, '');
    if (token) {
      const headers = new HttpHeaders({
        'Authorization': token,
      });

      return this.http.get<TicketsSearchResponse>(`${this.URL}/atendimentos`, {
        headers,
        params: makeHttpParams(request),
      });
    }
  }

  /**
   * Obtém apenas o contador de tickets (otimizado para dashboards)
   * @param status Status dos tickets (open, closed, etc)
   * @returns Observable com o total de tickets
   */
  getTicketCounter(status: string = 'open'): Observable<TicketCounterResponse> {
    const token = localStorage.getItem('ls.token').replace(/"/g, '');
    if (token) {
      const headers = new HttpHeaders({
        'Authorization': token,
      });

      return this.http.get<TicketCounterResponse>(`${this.URL}/atendimentos/contador`, {
        headers,
        params: makeHttpParams({ status }),
      });
    }
  }

}
